import NetxQueryClient, {
	type SuccessResponse,
} from '@netx/core-next/lib/queryClient';
export type {QueryError} from '@netx/core-next/lib/queryClient';
import {getResponseResults} from '@netx/core-next/utils/api';

export type CreateAttributeVocabularyFromFileRequestOptions = {
	fileName: string;
	name: string;
};

/**
 * `createAttributeVocabularyFromFile` request
 * (what gets sent to the server)
 */
export type CreateAttributeVocabularyFromFileRequest = [
	CreateAttributeVocabularyFromFileRequestOptions['name'],
	CreateAttributeVocabularyFromFileRequestOptions['fileName'],
];

/**
 * `createAttributeVocabularyFromFile` response
 * (what comes back from the server)
 */
export type CreateAttributeVocabularyFromFileResponse =
	SuccessResponse<CreateAttributeVocabularyFromFileResult>;

/**
 * `createAttributeVocabularyFromFile` result
 * (what is utilized from the server response)
 */
export type CreateAttributeVocabularyFromFileResult = string; // uuid

export const createAttributeVocabularyFromFileEndpoint =
	'createAttributeVocabularyFromFile';

/**
 * Process uploaded data set file
 * @param fetchParams Fetch params
 */
export const createAttributeVocabularyFromFile = async ({
	fileName,
	name,
}: CreateAttributeVocabularyFromFileRequestOptions) => {
	const client = NetxQueryClient();

	const requestParams: CreateAttributeVocabularyFromFileRequest = [
		name,
		fileName,
	];

	return client
		.post<CreateAttributeVocabularyFromFileResponse>(
			createAttributeVocabularyFromFileEndpoint,
			requestParams,
		)
		.then(getResponseResults);
};

export default createAttributeVocabularyFromFile;
